import { render } from "./ViktimateKrimit.vue?vue&type=template&id=4ed5d350&scoped=true"
import script from "./ViktimateKrimit.vue?vue&type=script&lang=js"
export * from "./ViktimateKrimit.vue?vue&type=script&lang=js"

import "./ViktimateKrimit.vue?vue&type=style&index=0&id=4ed5d350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed5d350"]])

export default __exports__